import { useRetailerType } from "@faire/marketplace-lib/stores/retailer/useRetailerType";

export const useSearchPageShouldShowProductFirstPageSubheaderText = () => {
  const { isNewUser } = useRetailerType();
  return isNewUser;
};
